// Accent color palette for properties + a deterministic fallback.
export const PROPERTY_COLORS = [
  { v: "#3b82f6", l: "Blue" },
  { v: "#6366f1", l: "Indigo" },
  { v: "#8b5cf6", l: "Violet" },
  { v: "#ec4899", l: "Pink" },
  { v: "#f43f5e", l: "Rose" },
  { v: "#f97316", l: "Orange" },
  { v: "#f59e0b", l: "Amber" },
  { v: "#10b981", l: "Emerald" },
  { v: "#14b8a6", l: "Teal" },
  { v: "#06b6d4", l: "Cyan" },
  { v: "#64748b", l: "Slate" },
];

// Returns the property's chosen color, or a stable fallback derived from its id/name.
export function propColor(p) {
  if (p?.color) return p.color;
  const key = String(p?.id || p?.name || "");
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  return PROPERTY_COLORS[h % PROPERTY_COLORS.length].v;
}
